import { useFormState } from "react-final-form";
import rffEvaluateFieldCondition from "../../../utils/finalForm/rffEvaluateFieldCondition";

/**
 * Renders its children only while a condition holds against the live form
 * values. Three call shapes, in increasing order of power:
 *
 *   <RffConditional field="borrowerHasSSN" value={true}>
 *   <RffConditional field="loanProductType" operator="includes" value={[...]}>
 *   <RffConditional operatorForMultiple="AND" rules={[{ field, operator, value }]}>
 *
 * Fields inside an unrendered branch are unregistered, which is what keeps the
 * step-level validation gate honest — it only ever sees the questions actually
 * being asked.
 */
const RffConditional = ({
  field,
  operator,
  value,
  rules,
  operatorForMultiple = "AND",
  condition: conditionObj,
  children,
}) => {
  const { values } = useFormState();

  let condition;

  if (conditionObj) {
    condition = conditionObj;
  } else if (rules) {
    condition = { operator: operatorForMultiple, rules };
  } else if (field) {
    condition = {
      operator: operator || "==",
      rules: [{ field, operator: operator || "==", value }],
    };
  } else {
    return <>{children}</>;
  }

  if (!rffEvaluateFieldCondition(condition, values)) return null;

  return children;
};

export default RffConditional;
